import { Component, Suspense } from "react";
import { MemoryRouter, Route, Routes } from "react-router-dom";
// import { ApmRoutes } from '@elastic/apm-rum-react';
import { getUrlParameter } from "../ts/infrastructure";
import { UserOnBoardDialog } from "./userOnBoard/UserOnBoardDialog";
import { withTranslation } from "react-i18next";

import SidePanel from "./side_panel/SidePanel";
import PortalSelector from "./portal_selector/PortalSelector";
import EngineeringDialog from "./dialog/EngineeringDialog";
import LogDialogBase from "./dialog/LogDialog";

const LogDialog = withTranslation()(LogDialogBase);

export class AddinRouter extends Component {
    private getInitialRoute() {
        const pathname = window.location.pathname;
        
        // Map the actual pathname to our routes and continue using MemoryRouter
        // This is necessary because the add-in is served from the root path in Outlook
        switch (pathname) {
            case '/onboarding':
                return '/onboarding';
            case '/eng':
                return '/eng';
            case '/debug-dialog':
                return '/debug-dialog';
            default:
                return '/';
        }
    }
    /**
     * This function run every time React decides to render the component.
     */
    public render() {
        const isPortal = getUrlParameter('portal');
        const initialRoute = this.getInitialRoute();
        return (
            <MemoryRouter initialEntries={[initialRoute]} initialIndex={0}>
                    <Suspense fallback={<div>Loading...</div>}>
                        <Routes>
                            {/* Doing this to serve both in the same preloaded and cached route / */}
                            <Route path="/" element={isPortal ? <PortalSelector /> : <SidePanel />} />
                            <Route path="/eng" element={ <EngineeringDialog />} />
                            <Route path="/onboarding" element={ <UserOnBoardDialog /> } />
                            <Route path="/debug-dialog" element={ <LogDialog /> } />
                        </Routes>
                    </Suspense>
            </MemoryRouter>
        );
    }
}